import loadable from '@loadable/component';

export const ReportsDetailGraphicConfigurationFilterChannel = loadable(
  () => import('./ReportsDetailGraphicConfigurationFilterChannel'),
);
